import { EventName, EventType, logMetricEvent } from '../services/eventService';

interface LogComponentInstallationEventParams {
    deviceId: string;
    vin: string;
    componentType: string;
    componentId: string;
    eventType: EventType;
    startTime: number;
    notes?: string;
    apiResponse?: any;
    error?: string;
    apiError?: any;
}

export const logComponentInstallationEvent = ({
    deviceId,
    vin,
    componentType,
    componentId,
    eventType,
    startTime,
    notes = '',
    apiResponse,
    error,
    apiError,
}: LogComponentInstallationEventParams) => {
    const miscEventData: any = {
        notes,
        startTime,
    };

    // Add success-specific data
    if (eventType === EventType.START && apiResponse) {
        miscEventData.apiResponse = apiResponse;
    }

    // Add failure-specific data
    if (eventType === EventType.FAILURE) {
        if (error) {
            miscEventData.error = error;
        }
        if (apiError) {
            miscEventData.apiError = apiError;
        }
    }

    logMetricEvent({
        deviceId,
        vin,
        eventName: EventName.DEVICE_COMPONENT_INSTALLATION,
        eventType,
        componentType,
        componentId,
        miscEventData,
        duration_ms: Date.now() - startTime,
    });
};
